import { render, staticRenderFns } from "./PublicContactSettings.vue?vue&type=template&id=3d4bf1f8&"
import script from "./PublicContactSettings.vue?vue&type=script&lang=js&"
export * from "./PublicContactSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports